<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ title | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body">
    <p class="pb-2 pt-2">{{ "CONFIRM_SSN_TEXT1" | globalTranslate }}</p>
    <nh-field
      [attr.aria-required]="true"
      label="{{ 'CONFIRM_SSN_TEXT2' | globalTranslate }}"
      [mandatory]="true"
    >
      <input
        placeholder="XXX-XX-XXXX"
        mask="000-00-0000"
        type="text"
        name="confirmssn"
        [attr.aria-label]="'CONFIRM_SSN_TEXT2' | globalTranslate"
        class="form-control"
        [formControl]="confirmssn"
        (keyup)="ssnValidate()"
        (keypress)="ssnValidate()"
        (focusout)="ssnValidate()"
        onCopy="return false"
        onDrag="return false"
        onDrop="return false"
        onPaste="return false"
      />
    </nh-field>
  </div>

  <div
    class="modal-footer align-button"
    [ngClass]="
      (!isFormValid() && !this.confirmssn.touched) ||
      (isFormValid() && this.confirmssn.touched)
        ? 'withoutError'
        : 'withError'
    "
  >
    <div class="me-2 ml-2">
      @if (showConfirm) {
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-secondary"
        (click)="onConfirm()"
        [disabled]="!isFormValid()"
      >
        {{ "SUBMIT" | globalTranslate }}
      </button>
      }
    </div>
    <div class="me-2 ml-2">
      @if (showDecline) {
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-link"
        (click)="onCancel()"
      >
        {{ declineButton | globalTranslate }}
      </button>
      }
    </div>
  </div>
</div>